// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"178ebf25","787":"1b4381c9"}[chunkId] + ".chunk.js";
};